import { Component, AfterViewInit } from '@angular/core'
import {ControlWidget} from 'ngx-schema-form'

@Component({
  selector: 'custom-date',
  template: `<div class="course-poll-block">
  <div class="field-title">
      {{ schema.title }}
  </div>
  <div *ngIf="schema.description" class="field-description">
      {{ schema.description }}
  </div>
  <input [name]="name" type="date" placeholder="Краткий ответ" [formControl]="control" [attr.required]="schema.required || null" >
</div>`
})
export class DateWidget extends ControlWidget {
}